/* app/ui/track */

define(
	'app/ui/track/load',[
		'app/ui/track/analytics/universal',
		'app/ui/track/component',
		'app/ui/track/external',
		'app/ui/track/preload',
	],

	function (Analytics, Component, External, Preload) {

		return {
			init: function () {
				if (document.querySelector('.js-track__calculator-access-form')) {
					require(['app/ui/track/calculator-access-form'], function (trackCalculatorAccessForm) {
						trackCalculatorAccessForm.init();
					});
				}

				if (document.querySelector('.js-track__calculator-form')) {
					require(['app/ui/track/calculator-form'], function (trackCalculatorForm) {
						trackCalculatorForm.init();
					});
				}

				// Initiate Analytics
				Analytics.init();

				// Initiate Global Page Tracking
				Preload.init();
				External.init();

				// Initiate Component Tracking
				Component.init();
			}
		};
	}
);
